import { render, staticRenderFns } from "./ScaleCreate.vue?vue&type=template&id=0e4e4a1f&scoped=true&lang=pug"
import script from "./ScaleCreate.vue?vue&type=script&lang=js"
export * from "./ScaleCreate.vue?vue&type=script&lang=js"
import style0 from "./ScaleCreate.vue?vue&type=style&index=0&id=0e4e4a1f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4e4a1f",
  null
  
)

export default component.exports